module.exports = __webpack_public_path__ + "img/img-love.51c85834.svg";